export const MagicWandIcon = ({
  fill = 'currentColor',
  width = '21',
  height = '21',
  viewBox = '0 0 21 21',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      // eslint-disable-next-line max-len
      d="M12.5059 3.5084V1.75229C12.5059 1.38859 12.8007 1.09375 13.1644 1.09375C13.5281 1.09375 13.8229 1.38859 13.8229 1.75229V3.5084C13.8229 3.8721 13.5281 4.16694 13.1644 4.16694C12.8007 4.16694 12.5059 3.8721 12.5059 3.5084Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M12.5059 14.045V12.2889C12.5059 11.9252 12.8007 11.6304 13.1644 11.6304C13.5281 11.6304 13.8229 11.9252 13.8229 12.2889V14.045C13.8229 14.4087 13.5281 14.7036 13.1644 14.7036C12.8007 14.7036 12.5059 14.4087 12.5059 14.045Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M8.77402 7.24023C9.13772 7.24023 9.43256 7.53507 9.43256 7.89877C9.43256 8.26248 9.13772 8.55731 8.77402 8.55731H7.01792C6.65421 8.55731 6.35938 8.26248 6.35938 7.89877C6.35938 7.53507 6.65421 7.24023 7.01792 7.24023H8.77402Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M19.3102 7.24011C19.6739 7.24011 19.9687 7.53495 19.9687 7.89865C19.9687 8.26235 19.6739 8.55719 19.3102 8.55719H17.554C17.1903 8.55719 16.8955 8.26235 16.8955 7.89865C16.8955 7.53495 17.1903 7.24011 17.554 7.24011H19.3102Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M15.1567 9.89161C15.4139 9.63444 15.8308 9.63444 16.088 9.89161L17.1418 10.9454C17.3988 11.2026 17.3989 11.6195 17.1418 11.8767C16.8847 12.1338 16.4678 12.1337 16.2106 11.8767L15.1567 10.8228C14.8996 10.5657 14.8996 10.1488 15.1567 9.89161Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M13.173 7.24023C13.5367 7.24023 13.8315 7.53507 13.8315 7.89877C13.8315 8.26248 13.5367 8.55731 13.173 8.55731H13.1644C12.8007 8.55731 12.5059 8.26248 12.5059 7.89877C12.5059 7.53507 12.8007 7.24023 13.1644 7.24023H13.173Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M16.2105 3.92087C16.4677 3.66378 16.8846 3.66372 17.1418 3.92087C17.3988 4.17802 17.3988 4.59493 17.1418 4.85208L16.0879 5.90592C15.8308 6.16298 15.4139 6.16298 15.1567 5.90592C14.8996 5.64877 14.8996 5.23189 15.1567 4.9747L16.2105 3.92087Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M10.0641 10.0671C10.3213 9.80997 10.7382 9.80997 10.9953 10.0671C11.2525 10.3243 11.2525 10.7412 10.9953 10.9984L3.09285 18.9008C2.83567 19.158 2.41881 19.158 2.16163 18.9008C1.90446 18.6437 1.90446 18.2268 2.16163 17.9696L10.0641 10.0671Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M9.18605 3.92079C9.44322 3.66361 9.86009 3.66361 10.1173 3.92079L11.1711 4.97462C11.4281 5.23181 11.4282 5.64872 11.1711 5.90584C10.914 6.16296 10.4971 6.16284 10.2399 5.90584L9.18605 4.852C8.92887 4.59483 8.92887 4.17796 9.18605 3.92079Z"
      fill={fill}
    />
  </svg>
)
